export const formatName = (s) => (s && s.length > 22 ? s.slice(0, 22) + "…" : s || "Unknown");

export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.split(" ");
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

export const formatTime = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  const now = new Date();
  const diff = now - date;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  if (hours < 24) {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
  }
  if (hours < 48) {
    return "Yesterday";
  }
  if (days < 7) {
    return date.toLocaleDateString("en-US", { day: "numeric", month: "short" });
  }
  return date.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
};

export const nowHM = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

